import { Grid, GridProps, styled } from '@mui/material'
import { themeUtils } from 'styles/theme'

interface SearchContentContainerProps extends GridProps {
  $expandedMap?: boolean
}

export const SearchContentContainer = styled(
  ({ $expandedMap, ...props }: SearchContentContainerProps) => (
    <Grid {...props} />
  )
)`
  transition-delay: ${({ $expandedMap }) => ($expandedMap ? '0s' : '0.2s')};
  order: ${({ $expandedMap }) => ($expandedMap ? 1 : 0)};
  ${themeUtils.maxWidth.md} {
    width: 100%;
  }
`

export const MapContainer = styled(Grid)`
  margin-left: auto;
  transition: all 0.2s ease-in-out;
`
